import { getStepIcon } from "../utils/utils";
import { HeaderNavComponent } from "./header-nav-compontent";
import { workflowTemplates } from "../sample_assets/workflow_templates";
import { Workflow } from "../api/models/Workflows";
import { caseStudies } from "../sample_assets/case_studies";

export const LearningCenterPage = () => {
    document.title = "PocketQuant | Learning Center"

    return (
        <div className="learning-center-page min-h-screen">
            <HeaderNavComponent variant="product" />
            <div className="flex flex-col items-center mt-4">
                <h1 className="text-4xl font-bold mb-4">Learning Center</h1>
            </div>

            <h2 className="text-2xl ml-4 text-gray-400 text-left">Featured Templates</h2>
            {/* card layout */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                {workflowTemplates.map((workflow, index) =>
                    <TemplateCard key={workflow.id} workflow={workflow} />
                )}
            </div>

            <h2 className="text-2xl ml-4 text-gray-400 text-left">Case Studies</h2>
            {/* card layout */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                {caseStudies.map((caseStudy, index) =>
                    <div onClick={()=>{
                        window.location.href = `/case-study?caseStudyId=${caseStudy.id}`;
                    }} key={caseStudy.id} className="bg-white/[0.6] cursor-pointer shadow-md rounded-lg p-4 hover:border hover:border-gray-400 hover:shadow-lg transform hover:-translate-y-1 transition-all duration-200">
                        <h3 className="text-xl font-light mb-2">{caseStudy.name}</h3>
                        <p className="text-gray-500">{caseStudy.description}</p>
                        {/* pill for tags */}
                        <div className="flex flex-wrap mt-2">
                            {caseStudy.tags.map((tag, index) => (
                                <span key={index} className="bg-gray-200 text-gray-700 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded-full">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

const TemplateCard = ({ workflow }: { workflow: Workflow }) => {

    return (
        <div className="bg-white/[0.6] cursor-pointer shadow-md rounded-lg p-4 hover:border hover:border-gray-400 hover:shadow-lg transform hover:-translate-y-1 transition-all duration-200">
            <h3 className="text-xl font-light mb-2">{workflow.name}</h3>
            <div className="flex items-center mb-2">
                {workflow.steps.map((s, index) => (
                    getStepIcon(s.stepType, 'w-6 h-6 mr-2 text-gray-500')
                ))}

                <button className="ml-auto py-2 px-4 bg-orange-600 text-white font-bold rounded-lg transition duration-300"
                    onClick={() => {
                        window.location.href = `/workflows?templateId=${workflow.id}`;
                    }}
                >
                    Try Template
                </button>
            </div>
        </div>
    )
}
